import { testMcpConnection, USER_MCP_QUERY_KEYS } from '../../api';

/**
 * Single source of truth for the per-MCP health (`/test`) query. Both `useTestMcpConnection` (the
 * My MCPs badge, one query) and `useAgentMcpStatus` (the composer, a `useQueries` fan-out) build
 * their query from this, so key + fn + staleTime can't drift between the two surfaces — and because
 * the key is identical, they share one cache entry per MCP (a check or invalidation in one is seen
 * by the other). staleTime mirrors the server-side ~30s cache so repeated mounts don't re-hit it.
 */
export const mcpHealthQueryOptions = (mcpCatalogId: string) => ({
  queryKey: USER_MCP_QUERY_KEYS.health(mcpCatalogId),
  queryFn: () => testMcpConnection(mcpCatalogId),
  staleTime: 30_000,
});
